const VISIT_STATUS_VARIANTS = {
  VISITADO: 'success',
  'NO VISITADO': 'danger',
  PENDIENTE: 'warning',
  'SIN GEOCERCA': 'neutral',
  visited: 'success',
  no_visited: 'danger',
  pending: 'warning',
  no_location: 'neutral',
  'visited-style': 'success',
  'no-visited-style': 'danger',
  'pending-visit-style': 'warning',
  'no-gps-style': 'neutral'
}

export const VISIT_ACTIVITY_CHIP_VARIANT = 'info'

export function getVisitStatusChipVariant(status) {
  return VISIT_STATUS_VARIANTS[status] || 'neutral'
}
